import type { JSX } from 'react'
import { Badge, type BadgeProps } from '@mantine/core'
import { IconAlertTriangle } from '@tabler/icons-react'

/**
 * The "Abnormal" marker shown when a lab trend has at least one out-of-range point. Shared so the
 * Assistant chart and the Clinical Summary surface the identical indicator.
 */
export const AbnormalBadge = (props: BadgeProps): JSX.Element => (
  <Badge color="red" variant="light" leftSection={<IconAlertTriangle size={12} />} {...props}>
    Abnormal
  </Badge>
)
